import { NumericResultType } from "@app/projects/results/accuracy";

export function formatHelper(
  value: unknown,
  format?: NumericResultType): React.ReactNode {
  if (value === null || value === undefined) return "---";

  switch (format) {
    case NumericResultType.Count:
      return (value as number).toLocaleString();
    case NumericResultType.Score:
      return (value as number).toFixed(1);
    case NumericResultType.Percent:
      if (value === 0.0) return "---";
      return (value as number).toFixed(1);
    default:
      return `${value}%`;
  }
}